// 导航分组照文档 18 §9.2；资料与设置按用户要求使用彩色图标，权限口径照老系统菜单。
// v2 还没做的模块，点了直接进老系统同一页面（legacy），两个前端共用会话。

export type NavItem = {
  key: string;
  label: string;
  short: string;
  icon: string;
  tone?: 'blue' | 'violet' | 'red' | 'green' | 'amber' | 'orange';
  perms: string[];
  /** v2 内的路由；没有就走老系统 */
  to?: string;
  /** 这些路径开头的页面也算本模块（导航高亮用） */
  match?: string[];
  legacy: string;
  group: 'biz' | 'data';
};

export const NAV: NavItem[] = [
  { key: 'home', label: '主屏', short: '主屏', icon: 'dash', tone: 'blue', perms: ['dashboard.read'], to: '/', legacy: '/dashboard', group: 'biz' },
  { key: 'orders', label: '订单', short: '订单', icon: 'cart', tone: 'blue', perms: ['orders.read.all', 'orders.read.own', 'orders.read.assigned'], to: '/orders', match: ['/orders'], legacy: '/orders', group: 'biz' },
  { key: 'shipments', label: '发货', short: '发货', icon: 'truck', tone: 'violet', perms: ['shipments.read'], to: '/shipments', match: ['/shipments'], legacy: '/shipments', group: 'biz' },
  { key: 'exceptions', label: '异常售后', short: '异常', icon: 'alert', tone: 'red', perms: ['exceptions.read'], to: '/exceptions', match: ['/exceptions'], legacy: '/order-exceptions', group: 'biz' },
  { key: 'purchase', label: '采购', short: '采购', icon: 'inbox', tone: 'green', perms: ['purchase.read', 'purchase.suggestions.read'], to: '/purchase-orders', match: ['/purchase-orders', '/purchase-suggestions'], legacy: '/purchase-orders', group: 'biz' },
  { key: 'inventory', label: '库存', short: '库存', icon: 'box', tone: 'amber', perms: ['inventory.read'], to: '/inventory', match: ['/inventory'], legacy: '/inventory', group: 'biz' },
  { key: 'settlements', label: '往来结算', short: '结算', icon: 'bank', tone: 'violet', perms: ['settlements.overview.read', 'settlements.customer.read', 'settlements.supplier.read', 'settlements.statement.read'], to: '/settlements', match: ['/settlements'], legacy: '/settlements', group: 'biz' },
  { key: 'reports', label: '经营报表', short: '报表', icon: 'chart', tone: 'blue', perms: ['reports.business.read'], to: '/reports', legacy: '/reports', group: 'biz' },
  { key: 'taobao', label: '淘宝店', short: '淘宝店', icon: 'flag', tone: 'orange', perms: ['taobao.manage'], to: '/taobao', legacy: '/taobao', group: 'biz' },
  { key: 'products', label: '产品资料', short: '产品', icon: 'book', tone: 'violet', perms: ['products.read', 'gallery.read'], to: '/products', match: ['/products', '/bundles', '/gallery'], legacy: '/products', group: 'data' },
  { key: 'customers', label: '客户 / 供应商', short: '客户', icon: 'team', tone: 'green', perms: ['customers.read', 'suppliers.read'], to: '/customers', match: ['/customers', '/suppliers'], legacy: '/customers', group: 'data' },
  { key: 'settings', label: '系统设置', short: '设置', icon: 'set', tone: 'blue', perms: ['system.settings.read', 'system.settings.write', 'users.read', 'roles.read', 'audit.read', 'imports.read', 'warehouses.write'], to: '/settings', match: ['/settings', '/users', '/audit-logs', '/imports'], legacy: '/settings', group: 'data' },
];

/** 高保真 T1b：跟单员可进入 V2 的无金额客户结算视角，不授予老版结算权限。 */
export function canSeeNavItem(item: NavItem, can: (...permissions: string[]) => boolean, role?: string) {
  return can(...item.perms) || item.key === 'settlements' && role === 'FOLLOWER' && can('orders.read.assigned') && can('customers.read');
}

/** 老系统地址：生产同源（空串），开发期是本机 3000 */
export const LEGACY_ORIGIN = import.meta.env.VITE_LEGACY_ORIGIN ?? '';
export const legacyHref = (path: string) => `${LEGACY_ORIGIN}${path}`;

/** 手机底部 Tab（文档 23 §8.1）：Tab 只放导航，开单等作业不占 Tab */
export const PHONE_TABS: { key: string; label: string; icon: string; to?: string; legacy?: string }[] = [
  { key: 'home', label: '主屏', icon: 'dash', to: '/' },
  { key: 'orders', label: '订单', icon: 'cart', to: '/orders' },
  { key: 'inventory', label: '库存', icon: 'box', to: '/inventory' },
  { key: 'apps', label: '应用', icon: 'apps', to: '/apps' },
  { key: 'me', label: '我的', icon: 'user', to: '/me' },
];
